import { forwardRef, useState, useEffect } from 'react';
import { Button, Tooltip, OverlayTrigger, Row } from 'react-bootstrap';
import { exportIcon } from '../helpers/icons';
import { exportAllDataApollo, copyToClipboard } from '../../utilities/export';
import { useDispatch, useSelector } from 'react-redux';
import { alertActions } from '../../redux/_actions';
import { sessionRoleType } from '../../redux/_constants';

const defaultContent = 'Copy Data';
const clickedContent = 'Copied Data to Clipboard';

const ToolTip = forwardRef(({ popper, children, show: _, ...props }, ref) => {
  useEffect(() => {
    popper.scheduleUpdate();
  }, [children, popper]);

  return (
    <Tooltip ref={ref} {...props}>
      {children}
    </Tooltip>
  );
});

export function ExportData({ sessionId, session }) {
  const [content, setContent] = useState(defaultContent);
  let timerId;
  const dispatch = useDispatch();
  const isAdmin = useSelector(
    (state) => state.session.role === sessionRoleType.ADMIN
  );

  const handleClick = () => {
    // Use session data passed as prop instead of making a new query
    if (session) {
      dispatch(alertActions.notification(clickedContent));
      setContent(clickedContent);
      setTimeout(() => {
        setContent(defaultContent);
      }, 2000);

      copyToClipboard(
        exportAllDataApollo(session, isAdmin)
          .map((row) => row.join('\t'))
          .join('\n')
      );
    }
  };

  const handleToggle = () => {
    if (content === clickedContent) {
      clearTimeout(timerId);
      timerId = setTimeout(() => {
        setContent(defaultContent);
        dispatch(alertActions.clear());
      }, 1000);
    }
  };

  return (
    <div className="exportData vCenter">
      <Row>
        <OverlayTrigger
          placement="top"
          delay={{ show: 700, hide: 0 }}
          overlay={<ToolTip id="popover-contained">{content}</ToolTip>}
          onToggle={handleToggle}
        >
          <Button variant="light" onClick={handleClick} className="vCenter">
            {exportIcon}
          </Button>
        </OverlayTrigger>
      </Row>
    </div>
  );
}
